import { LogisticReceivingItemStateEnum } from "@/models/enums/receive-items.enum";
import { TAX_CALCULATION } from "@/models/enums/tax.enum";
import { FormValue, ReceiveItemRow } from "@/store/goodsReceiptPrice.store";
import moment from "moment";

export const initFormValue = (): FormValue => ({
  branch: undefined,
  checklistNumber: "",
  currencyCode: "",
  currencyDesc: "",
  currencyRate: 0,
  description: "",
  grandTotal: 0,
  isCheck: false,
  journalId: "",
  journalNo: "",
  purchaseOrderId: "",
  purchaseOrderNumber: "",
  receiveDate: moment(),
  receiveItems: [],
  receiveNumber: "",
  status: "" as LogisticReceivingItemStateEnum,
  supplierBillToAddress: "",
  supplierDeliveryOrderNo: "",
  supplierId: "",
  supplierName: "",
  supplierShipToAddress: "",
  taxType: TAX_CALCULATION.EXCLUSIVE,
  termOfPayment: 0,
  totalDiscount: 0,
  totalProductPrice: 0,
  totalTax: 0,
  id: "",
  createdBy: "",
  createdDate: "",
  modifiedBy: "",
  modifiedDate: "",
  isLuxuryGoods: false
});

export const initFormRow = (): ReceiveItemRow => ({
  discountValue: 0,
  id: "",
  itemAssets: [],
  key: Math.random(),
  locationReceived: undefined,
  merk: "",
  partNumber: "",
  percentDiscount: 0,
  price: 0,
  productCode: "",
  productId: "",
  productName: "",
  productUom: "",
  productUomId: "",
  purchaseOrderLineId: "",
  qty: 0,
  qtyOutstanding: 0,
  qtyPO: 0,
  serialNumbers: [],
  tax: "",
  taxBase: "",
  taxCode: "",
  taxCodeId: "",
  taxRate: 0,
  totalPrice: "",
  trackAsAsset: false,
  isSearchLocation: false,
  locationOptions: [],
  loadingLocation: false,
  grossValue: "",
  inclusiveTaxRateId: "",
  inclusiveTaxRateName: "",
  inclusiveTaxRate: 0
});
